import {
  GET_INSTITUTION_HISTORICAL_POSITION_REQUEST,
  GET_INSTITUTION_HISTORICAL_POSITION_SUCCESS,
  GET_INSTITUTION_HISTORICAL_POSITION_FAILURE,
  statusType
} from '../../../actions'

const initial = {
  data: null,
  status: statusType.IDLE
}

const institutionHistoricalPositionReducer = (state = initial, action) => {
  switch (action.type) {
    case GET_INSTITUTION_HISTORICAL_POSITION_REQUEST:
      return {
        ...state,
        status: statusType.IN_PROGRESS
      }

    case GET_INSTITUTION_HISTORICAL_POSITION_SUCCESS:
      return {
        data: action.payload,
        status: statusType.SUCCESS
      }

    case GET_INSTITUTION_HISTORICAL_POSITION_FAILURE:
      return {
        status: statusType.ERROR
      }

    default:
      return state
  }
}

export default institutionHistoricalPositionReducer
